import { Action, ActionsList } from 'components';
import { useTranslation } from 'libs/i18n';
import { useDialog } from 'libs/ui/Dialog/useDialog';

import { DialogSignOrderFeature } from '../../features';
import { useFormContext } from '../../forms/orderForm';
import { useToggleEditable } from '../../hooks/useToggleEditable';
import { useOrderContext } from '../../providers/OrderProvider';
import { ActionType } from '../../types';

import { useActionsMap } from './useActionsMap';

export interface OrderFormActionsProps {
  actions: ActionType[];
}

export const OrderFormActions = ({ actions }: OrderFormActionsProps) => {
  const { t } = useTranslation();

  const actionsMap = useActionsMap();

  const { readOnly, initialValues } = useFormContext();

  const { order, onDelete, onDownloadOrder } = useOrderContext();

  const { enableEditable } = useToggleEditable();

  const {
    isOpen: isOpenSignDialog,
    open: openSignDialog,
    onClose: onCloseSignDialog,
  } = useDialog();

  const onClickAction = (action: ActionType) => {
    switch (action) {
      case ActionType.Sign:
        openSignDialog();
        break;
      case ActionType.Edit:
        enableEditable();
        break;
      case ActionType.Delete:
        onDelete();
        break;
      case ActionType.Download:
        onDownloadOrder();
        break;
      default:
        break;
    }
  };

  if (!readOnly || !order) {
    return null;
  }

  return (
    <>
      <ActionsList>
        {actions.map((action) => {
          const { Icon, label, color, borderColor } = actionsMap[action];
          return (
            <Action
              key={action}
              borderColor={borderColor}
              tooltip={t(label)}
              onClick={() => onClickAction(action)}
            >
              <Icon color={color} size={16} />
            </Action>
          );
        })}
      </ActionsList>

      <DialogSignOrderFeature
        executionPeriodInBusinessDays={
          initialValues?.executionPeriodInBusinessDays
        }
        isOpen={isOpenSignDialog}
        order={order}
        startDate={initialValues?.startDate}
        onClose={onCloseSignDialog}
      />
    </>
  );
};
